<!--
  ~ Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
<main class="tenant-login">
  <h2 class="container__title">
    Logging into tenant
  </h2>
</main>
